import { useMutation } from '@apollo/client'

import {
  SendVerificationEmail,
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables,
} from '@/clients/utoniq-core/schema'
import { useAuth, useMessage, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setMailInput } from '@/core/native/storage'

import { Action, State } from './template'
import type { EmailAddressFormValues } from './template/EmailAddressSettingForm'
/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user, updateEmail, isBoundWithSNS } = useAuth()
  const { router, routerPages } = useRouter()
  const { showError } = useMessage()
  const [sendVerifyEmail, { loading: verifyEmailSending }] = useMutation<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >(SendVerificationEmail)

  return {
    state: {
      email: user?.email || '',
      isBoundWithSNS,
      verifyEmailSending,
    },
    actions: {
      updateEmail: async ({ email, password }: EmailAddressFormValues) => {
        return updateEmail(email, password).catch((error: Error) => {
          throw error
        })
      },
      sendVerificationMail: async ({ email }) => {
        await sendVerifyEmail({ variables: { email } })
          .then(async () => {
            await setMailInput(email)
            router.push(routerPages.MailAuth)
          })
          .catch(showError)
      },
    },
  }
})
